import { useState } from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logoGDF from "../../assets/img/brasao.png";
import LegislacaoModal from "../modals/LegislacaoModal";

function Header() {
  const [showLegislacaoModal, setShowLegislacaoModal] = useState(false);
  
  const handleShowLegislacao = () => setShowLegislacaoModal(true);
  const handleCloseLegislacao = () => setShowLegislacaoModal(false);

  return (
    <>
    <header>
      <Navbar
        expand="lg"
        className="navbar-glass"
        variant="dark"
        fixed="top"
      >
        <Container>
          <Navbar.Brand as={NavLink} to="/">
            <img src={logoGDF} alt="Logo GDF" height="50" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarNav" />
          <Navbar.Collapse id="navbarNav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/" end>Início</Nav.Link>              
              <Nav.Link href="#" onClick={handleShowLegislacao}>Legislação</Nav.Link>
            </Nav>
            <Button as={NavLink} to="/login" className="btn-login">
              <i className="bi bi-person-circle me-2"></i>
              Área de Login
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
    
    {/* Modal de Legislação */}
    <LegislacaoModal show={showLegislacaoModal} onHide={handleCloseLegislacao} />
    </>
  );
}

export default Header;